import { useAtomValue } from 'jotai'
import React from 'react'
import { match } from 'ts-pattern'

import { dialogInfoAtom } from '../atoms'

import { DeleteBrandAccountDialog } from './DeleteBrandAccountDialog'
import { EditBrandAccountDialog } from './EditBrandAccountDialog'

export const Dialogs = () => {
  const dialogInfo = useAtomValue(dialogInfoAtom)

  return match(dialogInfo?.dialogType)
    .with(undefined, () => null)
    .with('create', 'update', () => <EditBrandAccountDialog />)
    .with('delete', () => <DeleteBrandAccountDialog />)
    .exhaustive()
}
